import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { getComponentName } from '@wix/da-react-context/pkg/helpers';
export const SisuContext = /*#__PURE__*/ React.createContext(false);
SisuContext.displayName = 'SisuContext';
// HOC for convenience...
export function withSisuContext(Component) {
    const DecoratedComponent = (props)=>{
        const isSisu = useContext(SisuContext);
        return /*#__PURE__*/ React.createElement(Component, _object_spread({
            isSisu: isSisu
        }, props));
    };
    DecoratedComponent.displayName = `withSisuContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}
